const booleanSchema = {
  isSelected: false,
  schema: "boolean",
  possibleValues: [
    {
      isTicked: false,
      value: "true",
      label: "True",
    },
    {
      isTicked: false,
      value: "false",
      label: "False",
    },
  ],
};

const singleValueSchema = {
  isSelected: false,
  schema: "boolean",
  possibleValues: [
    {
      isTicked: false,
      value: "true",
      label: "True",
    },
  ],
};

const riskFactorsSchema = {
  isSelected: false,
  possibleValues: [
    { isTicked: false, value: "Low", label: "low" },
    { isTicked: false, value: "Medium", label: "medium" },
    { isTicked: false, value: "High", label: "high" },
    { isTicked: false, value: "Blocked", label: "blocked" },
    { isTicked: false, value: "No Score", label: "cannotScore" },
  ],
};

const scoringStatusesSchema = {
  isSelected: false,
  possibleValues: [
    { isTicked: false, value: "approved", label: "approved" },
    { isTicked: false, value: "rejected", label: "rejected" },
    { isTicked: false, value: "finalised", label: "finalised" },
    { isTicked: false, value: "inprogress", label: "inprogress" },
  ],
};

const checkTypesSchema = {
  isSelected: false,
  possibleValues: [
    { isTicked: false, value: "AML", label: "AML" },
    { isTicked: false, value: "KYC", label: "KYC" },
  ],
};

const data = {
  confidential: booleanSchema,
  checkTypes: checkTypesSchema,
  cancelledCheck: booleanSchema,
  riskFactors: riskFactorsSchema,
  scoringStatuses: scoringStatusesSchema,
  ownerInSameGoup: singleValueSchema,
  onlyIfOwner: singleValueSchema,
  onlyUserCountry: singleValueSchema,
  geographyId: {
    isSelected: false,
    possibleValues: [],
  },
  processStates: {
    isSelected: false,
    possibleValues: [],
  },
  entityCategories: {
    isSelected: false,
    possibleValues: [],
  },
  countryIds: {
    isSelected: false,
    possibleValues: [],
  },
  entitySubCategories: {
    isSelected: false,
    possibleValues: [],
  },
};

const copyObject = (param) => {
  return JSON.parse(JSON.stringify(param));
};

export const getDefaultCondtions = (
  entityCategories = [],
  entitySubCategories = [],
  geographiesData = [],
  countriesData = [],
  allProcessSequence = []
) => {
  const allConditions = copyObject(data);
  allConditions.entityCategories.possibleValues = copyObject(entityCategories);
  allConditions.entitySubCategories.possibleValues =
    copyObject(entitySubCategories);
  allConditions.geographyId.possibleValues = copyObject(geographiesData);
  allConditions.countryIds.possibleValues = copyObject(countriesData);
  allConditions.processStates.possibleValues = copyObject(allProcessSequence);

  return allConditions;
};
